/**
 * Campaign Onboarding - Generic step handler (single-step actions)
 */
(function (global) {
  "use strict";

  var CampaignOnboarding = global.CampaignOnboarding;
  var stepInFlight = Object.create(null);

  function handleStep(stepId, url, method) {
    var config = CampaignOnboarding.STEPS[stepId];
    if (!config) {
      console.error("Unknown step:", stepId);
      return;
    }

    if (stepInFlight[stepId]) {
      return;
    }
    stepInFlight[stepId] = true;

    if (
      (method || config.method) === "GET" &&
      stepId === "fetch-confirm-payload"
    ) {
      var operationId = document.body.dataset.operationId;
      if (operationId) {
        var sep = url.indexOf("?") !== -1 ? "&" : "?";
        url = url + sep + "operation_id=" + encodeURIComponent(operationId);
      }
    }

    var btn = document.getElementById(stepId + "-btn");
    var resultDiv = document.getElementById(stepId + "-result");
    var successDiv = document.getElementById(stepId + "-success");
    var errorDiv = document.getElementById(stepId + "-error");
    var errorMessage = document.getElementById(stepId + "-error-message");
    var existingAlertId =
      config.existingAlertId != null
        ? config.existingAlertId
        : "existing-" + stepId.replace(/-/g, "") + "-alert";
    var existingAlert = document.getElementById(existingAlertId);

    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML =
      '<i class="glyphicon glyphicon-refresh spinning"></i> ' +
      (btn.dataset.loadingText || "Processing...");

    var options = {
      method: method || config.method || "POST",
      headers: {
        Accept: "application/json",
      },
    };

    if (options.method !== "GET") {
      options.headers["Content-Type"] = "application/json";
      var csrfToken = document.querySelector('meta[name="csrf-token"]');
      if (csrfToken) {
        options.headers["X-CSRF-Token"] = csrfToken.getAttribute("content");
      }
      var body = typeof config.getBody === "function" ? config.getBody() : {};
      options.body = JSON.stringify(body);
    }

    fetch(url, options)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.success) {
          if (
            config.async &&
            data.message &&
            data.message.includes("Job enqueued")
          ) {
            stepInFlight[stepId] = false;
            btn.innerHTML =
              '<i class="glyphicon glyphicon-refresh spinning"></i> Job running...';
            CampaignOnboarding.pollForStatus(
              stepId,
              config,
              btn,
              resultDiv,
              successDiv,
              errorDiv,
              errorMessage,
              existingAlert,
              originalText,
            );
            return;
          }

          resultDiv.classList.remove("hidden");
          successDiv.classList.remove("hidden");
          errorDiv.classList.add("hidden");
          if (existingAlert) existingAlert.classList.add("hidden");

          if (config.onSuccess) {
            config.onSuccess(data, CampaignOnboarding.createContext());
          }
          CampaignOnboarding.resetButton(btn, stepId, originalText);
        } else {
          resultDiv.classList.remove("hidden");
          successDiv.classList.add("hidden");
          errorDiv.classList.remove("hidden");
          errorMessage.textContent = data.error || "Unknown error occurred";
          CampaignOnboarding.resetButton(btn, stepId, originalText);
        }
        stepInFlight[stepId] = false;
      })
      .catch(function (error) {
        resultDiv.classList.remove("hidden");
        successDiv.classList.add("hidden");
        errorDiv.classList.remove("hidden");
        errorMessage.textContent = error.message || "Network error occurred";
        CampaignOnboarding.resetButton(btn, stepId, originalText);
        stepInFlight[stepId] = false;
      });
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.handleStep = handleStep;
})(typeof window !== "undefined" ? window : this);
